import { Component, Renderer2, TemplateRef, ViewChild } from "@angular/core";
import gsap from 'gsap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { EnquirySidebarService } from "../enquiry-sidebar/service/enquiry-sidebar.service";
declare const Calendly: any;
declare var YT: any;
@Component({
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
  providers: [],
  styles: [
    `.cell-totals {
      margin: 5px;
      text-align: center;
    }
    .badge {
      margin-right: 5px;
    }
    .custom-event {
      border: 1px solid silver;
    }
  `
  ]
})
export class LandingComponent {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  constructor(private sanitizer: DomSanitizer, private renderer: Renderer2,
    private router: Router,private enquiryService: EnquirySidebarService
  ) {
  }


  tl = gsap.timeline({ paused: true })
  mvHorizonVideos: SafeResourceUrl[] = [];
  topNewsPosts: { title: string; link: string }[] = [];
  ngOnInit() {
    const urls = [
      'https://www.youtube.com/embed/ZwoBobid0R8?si=ug4KikCayaoYvxxv'
    ];
    this.mvHorizonVideos = urls.map(url =>
      this.sanitizer.bypassSecurityTrustResourceUrl(url)
    );
    this.loadDropInBlogScript();
    const landingHeaderFeatureElements = document.querySelectorAll('.span-1');

    window.document.title = "ENL Solutions"

    gsap.fromTo(".landingQuote", { opacity: 0, x: -25 }, { opacity: 1, x: 0, duration: 0.66, stagger: 0.22 }).delay(1.5);
    gsap.fromTo(landingHeaderFeatureElements, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 2, stagger: 0.22 }).delay(1.5);
    // this.tl.to(".landingQuote", { duration: 0.1});
  }

  ngAfterViewInit() {
    this.playVideo(1);
    this.loadRoroWidget();
  }

  loadRoroWidget() {
    // The #roro-widget target only exists once this view has rendered, so the loader is injected
    // here rather than in index.html <head> (where it would run before Angular renders the div).
    const target = document.getElementById('roro-widget');
    if (!target || target.querySelector('iframe')) {
      return; // target not present, or the widget is already mounted (guards SPA re-navigation)
    }
    const script = document.createElement('script');
    script.src = 'https://agreeable-moss-0dd732703.7.azurestaticapps.net/loader.js';
    script.setAttribute('data-pk', 'pk_kK8IZ9-NH-NKuZII9Cf8Xp-_drRJbn9m8nOuMqnEjXY');
    script.setAttribute('data-api', 'https://app-api-enl-widget-dev-001.azurewebsites.net');
    script.setAttribute('data-title', 'Widget title');
    script.setAttribute('data-color', '#17325C');
    script.setAttribute('data-target', '#roro-widget');
    document.body.appendChild(script);
  }

  openCalendly() {
    const url = 'https://calendly.com/endre-enl/30min';
    window.open(url, '_blank');
  }

  isPlaying = false;
  player: any;

  playVideo(muteAudio: number) {
    this.isPlaying = true;
    setTimeout(() => {
      this.player = new YT.Player('yt-player', {
        width: '335',
        height: '220',
        videoId: 'ZwoBobid0R8',
        playerVars: {
          autoplay: 1,
          mute: muteAudio,
          controls: 1,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onStateChange: (event: any) => this.onPlayerStateChange(event)
        }
      });
    });
  }

  onPlayerStateChange(event: any) {
    if (event.data === YT.PlayerState.ENDED) {
      this.resetPlayer();
    }
  }

  resetPlayer() {
    this.isPlaying = false;
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }

  loadDropInBlogScript() {
    const script = document.createElement('script');
    script.src = 'https://dropinblog.com/js/embed.js';
    script.async = true;
    script.onload = () => {
      // Wait for content to render into dib-recent-post-list
      setTimeout(() => this.extractRecentPosts(), 1500); // Give it some time to populate
    };
    document.head.appendChild(script);
  }

  extractRecentPosts() {
    const recentPostContainer = document.getElementById('dib-recent-post-list');
    if (recentPostContainer) {
      const postElements = recentPostContainer.querySelectorAll('a');
      const posts = [];

      postElements.forEach((el, i) => {
        if (i < 6) {
          posts.push({
            title: el.textContent?.trim() || '',
            link: el.getAttribute('href') || '#'
          });
        }
      });

      this.topNewsPosts = posts;
    }
  }

  redirect(val: string) {

    if (val == 'price') {
      this.router.navigate(['planselection']);
    }
    else if (val == 'register') {
      this.router.navigate(['signup']);
    }else{
      this.enquiryService.open();
    }
  }
}
